module.exports = __webpack_public_path__ + "static/lastfire-2a1fbdea2b0f05e1e1b179bff89bb824.jpg";